module.exports = "table{margin-bottom:20px;width:100%}mat-form-field{padding:20px}mat-spinner{margin:auto}\n"